import React, { useState, useEffect } from "react";
import MoreRepayments from "./Payments Modals/MoreRepayment";
import { Column, Row } from "simple-flexbox";
import {
  Paper,
  makeStyles,
  TableBody,
  TableRow,
  TableCell,
  Toolbar,
  InputAdornment,
} from "@material-ui/core";
import Naira from "react-naira";
import useTable from "../../../utilities/useTable";
import { ToastContainer } from "react-toastify";
import StatComponent from "../../stat-page/StatComponent";
import "react-toastify/dist/ReactToastify.css";
import { connect } from "react-redux";
import Controls from "../../../controls/Controls";
import { Search } from "@material-ui/icons";
import AddIcon from "@material-ui/icons/Add";
import Popup from "../../../utilities/Popup";
import CloseIcon from "@material-ui/icons/Close";
import Notification from "../../../utilities/Notification";
import ConfirmDialog from "../../../utilities/ConfirmDialog";
import AddPaymentForm from "./Payments Modals/AddPaymentForm";
import Button from "@mui/material/Button";
import { Link } from "react-router-dom";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import PaymentForm from "./Payments Modals/AddPaymentForm";
import PaymentOutlinedIcon from "@material-ui/icons/PaymentOutlined";

const useStyles = makeStyles((theme) => ({
  pageContent: {
    margin: theme.spacing(1),
    padding: theme.spacing(3),
  },
  searchInput: {
    width: "75%",
  },
  newButton: {
    position: "absolute",
    right: "10px",
  },
}));

const headCells = [
  { id: "no", label: "Number of repayments" },
  { id: "amountPaid", label: "Amount" },
  { id: "amountOutstanding", label: "Outstanding" },
  { id: "financialCharge", label: "Fin. Charge" },
  { id: "repayments", label: "Repayments" },
  { id: "actions", label: "Actions", disableSorting: true },
];

const dates = function () {
  const date = new Date();
  const year = date.getFullYear();
  const month = date.getMonth();
};

export function Payment({
  payments,
  UpdatePayment,
  DeletePayment,
  LoadRepayments,
  LoadPayments,
  companyId,
  repayments,
  AddPayment,
  categories,
  accounts,
  accountTypes,
  paymentTypes,
  cardTypes,
}) {
  const classes = useStyles();
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [openPopup, setOpenPopup] = useState(false);
  const [addOpenPopup, setAddOpenPopup] = useState(false);
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(repayments, headCells, filterFn);

  useEffect(() => {
    LoadRepayments(payload);
    var payload = {
      id: 8,
    };
  }, []);

  const handleSearch = (e) => {
    let target = e.target;
   
    setFilterFn({
      fn: (items) => {
        var items_value=[];
        if (target.value === "") return items;
        else
        for(var i=0;i<items.length;i++){
          if(items[i].transactionReference.toLowerCase().startsWith(target.value.toLowerCase())){
            items_value.push(items[i])
          }
        }
      return items_value;
      },
    });
  };

  const addOrEdit = (payment, resetForm) => {
    var data = { ...payment, companyId: companyId };
    UpdatePayment(data);
    resetForm();
    // setRecordForEdit(null)
    setOpenPopup(false);
    setAddOpenPopup(false);
  };

  const addPayment = (payment, resetForm) => {
    var data = { ...payment, companyId: companyId };
    AddPayment(data);
    resetForm();
    setRecordForEdit(null);
    setOpenPopup(false);
    setAddOpenPopup(false);
  };

  const openInPopup = (item) => {
    setRecordForEdit(item);
    setOpenPopup(true);
  };

  const onDelete = (id) => {
    DeletePayment(id);
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false,
    });
  };

  return (
    <div className="container" style={{ paddingTop: "1rem" }}>
      <Column flexGrow={1}>
        <ToastContainer />
        <div style={{}}>
          <Controls.Input
            label="Search Payments by Payment Referencd"
            className={classes.searchInput}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search />
                </InputAdornment>
              ),
            }}
            onChange={handleSearch}
          />
        </div>
        <Paper className={classes.pageContent}>
          <div className="grid grid-cols-2">
            <h4>
              {" "}
              <strong>Repayments</strong>
            </h4>
            <div className="flex justify-end">
              <Link to="/company/credit/payment">
                <Controls.Button
                  text="Sub. Payments"
                  variant="outlined"
                  startIcon={<PaymentOutlinedIcon />}
                />
              </Link>
            </div>
          </div>

          <TblContainer>
            <TblHead />
            <TableBody>
              {recordsAfterPagingAndSorting().map((item) => (
                <TableRow key={item.id}>
                  <TableCell>{item.noOfRepayment}</TableCell>
                  <TableCell>
                    <Naira>{item.salesAmount}</Naira>
                  </TableCell>
                  <TableCell>
                    <Naira>{item.amountOutstanding}</Naira>
                  </TableCell>
                  <TableCell>
                    <Naira>{item.financingCharges}</Naira>
                  </TableCell>
                  <TableCell>
                    <Naira>{item.repayment}</Naira>
                  </TableCell>
                  <TableCell>
                    <Controls.ActionButton
                      color="primary"
                      onClick={() => {
                        openInPopup(item);
                      }}
                    >
                      <EditOutlinedIcon fontSize="small" />
                    </Controls.ActionButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </TblContainer>
          <TblPagination />
        </Paper>
        <Popup
          title="Repayment Form"
          openPopup={openPopup}
          setOpenPopup={setOpenPopup}
        >
          <PaymentForm
            recordForEdit={recordForEdit}
            addOrEdit={addOrEdit}
            categories={categories}
            accounts={accounts}
            accountTypes={accountTypes}
            paymentTypes={paymentTypes}
            cardTypes={cardTypes}
          />
        </Popup>
        <Popup
          title="Add Payment Form"
          openPopup={addOpenPopup}
          setOpenPopup={setAddOpenPopup}
        >
          <AddPaymentForm
            recordForEdit={recordForEdit}
            addOrEdit={addPayment}
            categories={categories}
            accounts={accounts}
            accountTypes={accountTypes}
            paymentTypes={paymentTypes}
            cardTypes={cardTypes}
          />
        </Popup>
        <Notification notify={notify} setNotify={setNotify} />
        <ConfirmDialog
          confirmDialog={confirmDialog}
          setConfirmDialog={setConfirmDialog}
        />
      </Column>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    buttonloader: state.utilityReducer.buttonloader,
    payments: state.salesReducer.payments,
    repayments: state.salesReducer.repayments,
    accountTypes: state.salesReducer.accountTypes,
    accounts: state.salesReducer.accounts,
    paymentTypes: state.salesReducer.paymentTypes,
    cardTypes: state.salesReducer.cardTypes,
  };
}
const mapDispatchToProps = (dispatch) => ({
  AddPayment(payload) {
    dispatch({ type: "ADD_PAYMENT", payload });
  },

  LoadRepayments(payload) {
    dispatch({ type: "LOAD_REPAYMENT", payload: payload });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Payment);
